// Module
var code = "<template> <ess-text value.bind=\"value\" label.bind=\"definition.description\" maxlength=\"200\" validate=\"true\" readonly.bind=\"disabled\"></ess-text> </template> ";
// Exports
module.exports = code;